import { Phone, Mail, ShieldCheck, Sparkles, Sun, Wrench, Recycle } from "lucide-react";
import { COMPANY, HERO_BG } from "../lib/constants";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[92vh] lg:min-h-screen flex items-center pt-28 pb-16 overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden="true"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/90 via-[#0A192F]/75 to-[#0A192F]/55" />
      <div className="absolute inset-0 bg-[#0A192F]/30" />

      {/* Decorative cyan glow */}
      <div className="pointer-events-none absolute -top-32 -left-24 w-[420px] h-[420px] rounded-full bg-[#00B4D8]/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-[-120px] right-[-80px] w-[380px] h-[380px] rounded-full bg-[#00B4D8]/10 blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 text-white text-xs font-semibold tracking-[0.18em] uppercase px-4 py-2 rounded-full">
            <Sun className="w-3.5 h-3.5 text-[#00B4D8]" />
            Tampa Bay · Solar Specialists
          </div>

          <h1
            data-testid="hero-headline"
            className="font-heading font-bold text-white mt-6 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance"
          >
            Professional Solar{" "}
            <span className="text-[#00B4D8]">Cleaning</span>,{" "}
            <span className="text-[#00B4D8]">Repair</span> &{" "}
            <span className="text-[#00B4D8]">Maintenance</span> Services
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-heading font-semibold text-white leading-tight max-w-2xl"
          >
            Complete Solar Care for Your Home
          </p>

          {/* Feature items */}
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-white/90 text-sm max-w-xl">
            <span className="inline-flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#00B4D8] shrink-0" />
              Licensed &amp; Insured
            </span>
            <span className="inline-flex items-center gap-2">
              <Wrench className="w-4 h-4 text-[#00B4D8] shrink-0" />
              Diagnostics &amp; Repairs
            </span>
            <span className="inline-flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-[#00B4D8] shrink-0" />
              Cleaning &amp; Maintenance
            </span>
            <span className="inline-flex items-center gap-2">
              <Recycle className="w-4 h-4 text-[#00B4D8] shrink-0" />
              Removal &amp; Reinstallation
            </span>
          </div>

          {/* CTAs */}
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="hero-call-btn"
              href={COMPANY.smsLink}
              className="group inline-flex items-center justify-center gap-2 bg-[#00B4D8] hover:bg-[#0096C7] text-white px-8 py-4 rounded-full font-semibold text-base shadow-lg shadow-cyan-500/30 transition-all duration-300 hover:-translate-y-1"
            >
              <Phone className="w-5 h-5" />
              Get A Free Estimate
            </a>
            <a
              data-testid="hero-email-btn"
              href={`mailto:${COMPANY.email}?subject=Solar%20Service%20Inquiry`}
              className="group inline-flex items-center justify-center gap-2 bg-transparent border-2 border-white/80 text-white hover:bg-white hover:text-[#0A192F] px-8 py-4 rounded-full font-semibold text-base transition-all duration-300"
            >
              <Mail className="w-5 h-5" />
              Contact Us
            </a>
          </div>
        </div>

        {/* Scroll cue */}
        <div className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 text-white/70">
          <div className="w-px h-10 bg-white/40" />
          <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        </div>
      </div>
    </section>
  );
}
